import { useEffect, useState } from 'react';
import * as React from 'react';
import styled from 'styled-components';

import { LinkedInIcon, TwitterIcon } from '../../icons/Icons';

import { LinkWithQuery } from './LinkWithQuery';

const Share = styled.div`
  align-items: center;
  display: flex;
  grid-gap: 16px;
  font-weight: ${({ theme }) => theme.fontWeight.BOLD};
  color: ${({ theme }) => theme.iconColor.DEFAULT};
  font-size: ${({ theme }) => theme.fontSize.DEFAULT};
  font-weight: var(
    --social-font-weight,
    ${({ theme }) => theme.fontWeight.SEMI_BOLD}
  );

  a {
    border-bottom: none;
    display: flex;
    transition: opacity
      ${({ theme }) => `${theme.animation.DURATION} ${theme.animation.EASING}`};

    &:active,
    &:focus,
    &:hover {
      background-color: transparent;
      opacity: 0.5;
    }
  }
`;

const Text = styled.span`
  text-transform: var(--social-text-transform, uppercase);
`;

interface SocialShareProps {
  title: string;
}

export const SocialShare: React.ComponentType<
  SocialShareProps & { className?: string }
> = React.memo(({ title, className }) => {
  const [currentUrl, setCurrentUrl] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentUrl(window.location.href);
    }
  }, []);

  const encodedUrl = encodeURIComponent(currentUrl);
  const encodedTitle = encodeURIComponent(title);

  const twitterUrl = `https://twitter.com/share?text=${encodedTitle}&url=${encodedUrl}`;
  const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`;
  return (
    <Share className={className}>
      <Text>Share:</Text>
      <LinkWithQuery isExternal={true} to={twitterUrl}>
        <TwitterIcon />
      </LinkWithQuery>
      <LinkWithQuery isExternal={true} to={linkedinUrl}>
        <LinkedInIcon />
      </LinkWithQuery>
    </Share>
  );
});
